import React from "react";
import { useSelector } from "react-redux";
import { hebrewDateType } from "../../../enums/hebrewDateType";
import NavigateLink from "../navigateLink/navigateLink";
import useHebrewDate from '../../../hooks/useHebrewDate ';
import Icon from "../../ui/icons/Icon";
import iconsList from "../../ui/icons/iconsList";
import classes from "./AssessmentItem.module.css";


const AssessmentItem = ({ assessment }) => {

    const getHebrewDate = useHebrewDate()
    const { domains } = useSelector(state => state.uiData);
    const domainObj = domains.find(d => d.name === assessment.domain);
    const domainName = domainObj?.text?.all?.he || domainObj?.name || "";
    const date = assessment?.toDate ? new Date(assessment.toDate) : assessment?.dueDate ? new Date(assessment.dueDate) : null;

    return (
        <NavigateLink link={assessment.link} >
            <div className={classes.AssessmentItem}>
                <div
                    className={classes.ColorBar}
                    style={{ backgroundColor: domainObj?.color || "gray" }}
                />

                <div className={classes.AssessmentContent}>
                    <div className={classes.Date}>
                        <Icon name={iconsList.task} size={"13px"} className={classes.Icon}></Icon>
                        {date && <>
                            <span className={classes.MetaPart}>
                                {date.toLocaleDateString("he-IL",  { day: "2-digit" , month: "2-digit", year: "2-digit"})}
                            </span>
                            <span className={classes.MetaPart}>
                                {getHebrewDate(date, hebrewDateType.day)}{" "}
                                {getHebrewDate(date, hebrewDateType.month)}
                            </span>
                        </>}
                        {domainName && (
                            <span className={classes.MetaPart}>{domainName}</span>
                        )}
                    </div>
                    <div className={classes.Name}>
                        {assessment.name}
                    </div>
                </div>
            </div>
        </NavigateLink >
    );
};

export default AssessmentItem; 